import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import ProductCard from '../components/ProductCard';

function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');

  useEffect(() => {
    async function loadProducts() {
      try {
        const snapshot = await getDocs(collection(db, 'products'));
        const productList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setProducts(productList);
      } catch (err) {
        console.error('Error loading products:', err);
      }
      setLoading(false);
    }
    loadProducts();
  }, []);

  // Filter by search term
  const filtered = products.filter(p => {
    const term = searchTerm.toLowerCase();
    return (
      p.name.toLowerCase().includes(term) ||
      p.description.toLowerCase().includes(term)
    );
  });

  // Sort results
  const sorted = [...filtered].sort((a, b) => {
    if (sortBy === 'price-low') return a.price - b.price;
    if (sortBy === 'price-high') return b.price - a.price;
    if (sortBy === 'name') return a.name.localeCompare(b.name);
    if (sortBy === 'stock-high') return (b.stock ?? 0) - (a.stock ?? 0);
    return 0;
  });

  return (
    <div className="container py-5">
      <h4
        className="fw-bold text-uppercase mb-4"
        style={{ letterSpacing: '0.08em' }}
      >
        All Products
      </h4>

      {/* Search + sort */}
      <div className="row mb-4 g-3 align-items-center">
        <div className="col-md-8">
          <input
            type="text"
            className="form-control"
            style={{ borderRadius: '2px' }}
            placeholder="Search products..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="col-md-4">
          <select
            className="form-select"
            style={{ borderRadius: '2px' }}
            value={sortBy}
            onChange={e => setSortBy(e.target.value)}
          >
            <option value="name">Name (A–Z)</option>
            <option value="price-low">Price: Low → High</option>
            <option value="price-high">Price: High → Low</option>
            <option value="stock-high">Availability: Most In Stock</option>
          </select>
        </div>
      </div>

      {!loading && (
        <p className="text-muted small mb-3">
          {sorted.length} product{sorted.length !== 1 ? 's' : ''}
          {searchTerm && ` matching "${searchTerm}"`}
        </p>
      )}

      {loading ? (
        <div className="text-center py-5">
          <div
            className="spinner-border spinner-border-sm"
            style={{ color: '#c84b11' }}
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : sorted.length > 0 ? (
        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-3">
          {sorted.map(product => (
            <div className="col" key={product.id}>
              <ProductCard product={product} />
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-5">
          <p className="text-muted mb-2">No products found.</p>
          {searchTerm && (
            <button
              className="btn btn-outline-secondary btn-sm"
              style={{ borderRadius: '2px' }}
              onClick={() => setSearchTerm('')}
            >
              Clear Search
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default Products;
